import React, { Component } from "react";

export default class CustomPackage extends Component {
  render() {
    const { message, selectedIconImageURL, colorSelected } = this.props;
    return (
      <div className="bg-white text-center mt-117 last-step-image" style={{ position: "relative"}}>
        {/*<p>Mensaje: {message !== 'empty' && message}</p>
        <p>Color Selected: {colorSelected}</p>
        selectedIconImageURL && (
          <figure>
            <img src={selectedIconImageURL} alt="Icono" />
          </figure>
        )*/}
      <div style={{ position: "absolute", top: "0", left:  "0", right: "0", bottom: "0", display: "flex", justifyContent: "center"}}>
        <svg
          style={{ maxWidth: "370px", height: "auto", width: "100%" }}
          width="2653px"
          height="3010px"
          viewBox="0 0 2653 3010"
          version="1.1"
          colorProfile="sRGB"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <title>lippysvg</title>
          <desc>Created with Sketch.</desc>
          <defs>
            <linearGradient
              x1="50%"
              y1="0%"
              x2="0%"
              y2="100%"
              id="last_linearGradient-1"
            >
              <stop stopColor="#EEEEEE" offset="0%"></stop>
              <stop stopColor="#F6F6F6" offset="71.0395592%"></stop>
              <stop stopColor="#F4F2F2" offset="100%"></stop>
            </linearGradient>
            <linearGradient
              x1="50%"
              y1="0%"
              x2="0.784636922%"
              y2="96.9596469%"
              id="last_linearGradient-2"
            >
              <stop stopColor="#F7F7F7" offset="0%"></stop>
              <stop stopColor="#F1F1F1" offset="100%"></stop>
            </linearGradient>
            <linearGradient
              x1="50%"
              y1="0%"
              x2="0.784636922%"
              y2="96.9596469%"
              id="last_linearGradient-3"
            >
              <stop stopColor="#FFFFFF" offset="0%"></stop>
              <stop
                stopColor="#FFFFFF"
                stopOpacity="0"
                offset="84.9191655%"
              ></stop>
              <stop stopColor="#FFFFFF" offset="100%"></stop>
            </linearGradient>
            <linearGradient
              x1="72.8927556%"
              y1="55.1495824%"
              x2="39.7452549%"
              y2="55.1495824%"
              id="last_linearGradient-4"
            >
              <stop stopColor="#FFFFFF" stopOpacity="0" offset="0%"></stop>
              <stop stopColor="#FFFFFF" offset="48.6610368%"></stop>
              <stop stopColor="#FFFDFD" stopOpacity="0" offset="100%"></stop>
            </linearGradient>
            <linearGradient
              x1="50%"
              y1="0%"
              x2="50%"
              y2="100%"
              id="last_linearGradient-5"
            >
              <stop stopColor="#E2E2E2" offset="0%"></stop>
              <stop stopColor="#F6F6F6" offset="100%"></stop>
            </linearGradient>
            <linearGradient
              x1="50%"
              y1="32.2209176%"
              x2="50%"
              y2="100%"
              id="last_linearGradient-6"
            >
              <stop stopColor="#E2E2E2" offset="0%"></stop>
              <stop
                stopColor="#F3F3F3"
                stopOpacity="0.8"
                offset="31.6833326%"
              ></stop>
              <stop
                stopColor="#FFFFFF"
                stopOpacity="0.9"
                offset="70.8901018%"
              ></stop>
              <stop stopColor="#FCFCFC" stopOpacity="0.8" offset="100%"></stop>
              <stop stopColor="#F6F6F6" offset="100%"></stop>
            </linearGradient>
            <filter
              x="-0.6%"
              y="-9.7%"
              width="101.2%"
              height="119.4%"
              filterUnits="objectBoundingBox"
              id="last_filter-7"
            >
              <feGaussianBlur
                stdDeviation="1"
                in="SourceGraphic"
              ></feGaussianBlur>
            </filter>
            <linearGradient
              x1="27.4653846%"
              y1="50%"
              x2="94.4474562%"
              y2="50%"
              id="last_linearGradient-8"
            >
              <stop stopColor="#000000" offset="0%"></stop>
              <stop
                stopColor="#000000"
                stopOpacity="0.5"
                offset="43.1448699%"
              ></stop>
              <stop
                stopColor="#000000"
                stopOpacity="0"
                offset="72.4581009%"
              ></stop>
              <stop
                stopColor="#000000"
                stopOpacity="0"
                offset="81.3868239%"
              ></stop>
              <stop stopColor="#000000" stopOpacity="0.25" offset="100%"></stop>
            </linearGradient>
            <linearGradient
              x1="100%"
              y1="50%"
              x2="0%"
              y2="50%"
              id="last_linearGradient-9"
            >
              <stop stopColor="#FFFFFF" offset="0%"></stop>
              <stop stopColor="#FFFFFF" stopOpacity="0" offset="100%"></stop>
            </linearGradient>
            <filter
              x="-6.3%"
              y="-1.5%"
              width="112.6%"
              height="102.9%"
              filterUnits="objectBoundingBox"
              id="last_filter-10"
            >
              <feGaussianBlur
                stdDeviation="3.56137362"
                in="SourceGraphic"
              ></feGaussianBlur>
            </filter>
            <linearGradient
              x1="85.1837733%"
              y1="50%"
              x2="23.3381503%"
              y2="50%"
              id="last_linearGradient-11"
            >
              <stop stopColor="#FFFFFF" offset="0%"></stop>
              <stop stopColor="#FFFFFF" stopOpacity="0" offset="100%"></stop>
            </linearGradient>
            <filter
              x="-13.5%"
              y="-1.9%"
              width="127.1%"
              height="103.8%"
              filterUnits="objectBoundingBox"
              id="last_filter-12"
            >
              <feGaussianBlur
                stdDeviation="4.18985132"
                in="SourceGraphic"
              ></feGaussianBlur>
            </filter>
            <radialGradient
              cx="50%"
              cy="100%"
              fx="50%"
              fy="100%"
              r="71.2650936%"
              gradientTransform="translate(0.500000,1.000000),scale(0.199906,1.000000),rotate(-90.000000),scale(1.000000,20.400413),translate(-0.500000,-1.000000)"
              id="last_radialGradient-13"
            >
              <stop stopColor="#934A80" offset="0%"></stop>
              <stop
                stopColor="#9F548C"
                stopOpacity="0.846013728"
                offset="36.8858382%"
              ></stop>
              <stop stopColor="#E488CC" stopOpacity="0" offset="100%"></stop>
            </radialGradient>
            <radialGradient
              cx="57.6337088%"
              cy="50%"
              fx="57.6337088%"
              fy="50%"
              r="178.840177%"
              gradientTransform="translate(0.576337,0.500000),scale(1.000000,0.902692),rotate(-112.094420),scale(1.000000,1.063600),translate(-0.576337,-0.500000)"
              id="last_radialGradient-14"
            >
              <stop stopColor="#FFFFFF" stopOpacity="0.1" offset="0%"></stop>
              <stop stopColor="#F3BDE8" offset="100%"></stop>
            </radialGradient>
            <radialGradient
              cx="87.930765%"
              cy="80.0706652%"
              fx="87.930765%"
              fy="80.0706652%"
              r="84.1208754%"
              gradientTransform="translate(0.879308,0.800707),scale(1.000000,0.902692),rotate(116.801947),scale(1.000000,0.849862),translate(-0.879308,-0.800707)"
              id="last_radialGradient-15"
            >
              <stop stopColor="#000000" stopOpacity="0" offset="0%"></stop>
              <stop
                stopColor="#000000"
                stopOpacity="0"
                offset="58.8353504%"
              ></stop>
              <stop stopColor="#000000" stopOpacity="0.35" offset="100%"></stop>
            </radialGradient>
            <linearGradient
              x1="50%"
              y1="0%"
              x2="50%"
              y2="100%"
              id="last_linearGradient-16"
            >
              <stop stopColor="#E6E6E6" offset="0%"></stop>
              <stop stopColor="#EFEFF2" offset="100%"></stop>
            </linearGradient>
            <linearGradient
              x1="50%"
              y1="0%"
              x2="50%"
              y2="100%"
              id="last_linearGradient-17"
            >
              <stop stopColor="#F4F4F4" offset="0%"></stop>
              <stop stopColor="#EFEFF2" offset="100%"></stop>
            </linearGradient>
            <linearGradient
              x1="-1.11022302e-14%"
              y1="50%"
              x2="100%"
              y2="50%"
              id="last_linearGradient-18"
            >
              <stop stopColor="#FFFFFF" stopOpacity="0.6" offset="0%"></stop>
              <stop stopColor="#FFFFFF" stopOpacity="0" offset="100%"></stop>
            </linearGradient>
            <radialGradient
              cx="50%"
              cy="100%"
              fx="50%"
              fy="100%"
              r="36.3601613%"
              gradientTransform="translate(0.500000,1.000000),scale(0.260437,1.000000),rotate(-90.000000),scale(1.000000,20.400413),translate(-0.500000,-1.000000)"
              id="last_radialGradient-19"
            >
              <stop stopColor="#B1B1B1" offset="0%"></stop>
              <stop
                stopColor="#DCDCDC"
                stopOpacity="0.846013728"
                offset="30.082202%"
              ></stop>
              <stop stopColor="#FFFFFF" stopOpacity="0" offset="100%"></stop>
            </radialGradient>
            <linearGradient
              x1="7.49661093%"
              y1="50%"
              x2="100%"
              y2="50%"
              id="last_linearGradient-20"
            >
              <stop stopColor="#000000" stopOpacity="0.2" offset="0%"></stop>
              <stop
                stopColor="#000000"
                stopOpacity="0"
                offset="24.8885364%"
              ></stop>
              <stop
                stopColor="#000000"
                stopOpacity="0"
                offset="50.1580564%"
              ></stop>
              <stop
                stopColor="#E5E5E5"
                stopOpacity="0.4"
                offset="90.1106433%"
              ></stop>
              <stop stopColor="#000000" stopOpacity="0" offset="100%"></stop>
            </linearGradient>
            <linearGradient
              x1="-1.11022302e-14%"
              y1="50%"
              x2="100%"
              y2="50%"
              id="last_linearGradient-21"
            >
              <stop stopColor="#FFFFFF" offset="0%"></stop>
              <stop stopColor="#FFFFFF" stopOpacity="0" offset="100%"></stop>
            </linearGradient>
            <linearGradient
              x1="-2.22044605e-14%"
              y1="50%"
              x2="100%"
              y2="50%"
              id="last_linearGradient-22"
            >
              <stop stopColor="#CECECF" offset="0%"></stop>
              <stop stopColor="#FFFFFF" stopOpacity="0" offset="100%"></stop>
            </linearGradient>
            <radialGradient
              cx="28.0251673%"
              cy="16.1821998%"
              fx="28.0251673%"
              fy="16.1821998%"
              r="123.741482%"
              gradientTransform="translate(0.280252,0.161822),scale(1.000000,0.875338),rotate(-113.689663),scale(1.000000,1.931800),translate(-0.280252,-0.161822)"
              id="last_radialGradient-23"
            >
              <stop stopColor="#FFFFFF" stopOpacity="0" offset="0%"></stop>
              <stop stopColor="#FFFFFF" offset="100%"></stop>
            </radialGradient>
            <radialGradient
              cx="71.5844488%"
              cy="16.3978692%"
              fx="71.5844488%"
              fy="16.3978692%"
              r="58.2419826%"
              id="last_radialGradient-24"
            >
              <stop stopColor="#FFFFFF" offset="0%"></stop>
              <stop stopColor="#D3D4D2" offset="100%"></stop>
            </radialGradient>
            <radialGradient
              cx="71.5844488%"
              cy="17.5248873%"
              fx="71.5844488%"
              fy="17.5248873%"
              r="55.1778609%"
              id="last_radialGradient-25"
            >
              <stop stopColor="#FFFFFF" stopOpacity="0" offset="0%"></stop>
              <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="100%"></stop>
            </radialGradient>
            <filter
              x="-22.0%"
              y="-22.0%"
              width="143.9%"
              height="143.9%"
              filterUnits="objectBoundingBox"
              id="last_filter-26"
            >
              <feGaussianBlur
                stdDeviation="3"
                in="SourceGraphic"
              ></feGaussianBlur>
            </filter>
            <filter
              x="-22.0%"
              y="-22.0%"
              width="143.9%"
              height="143.9%"
              filterUnits="objectBoundingBox"
              id="last_filter-27"
            >
              <feGaussianBlur
                stdDeviation="3"
                in="SourceGraphic"
              ></feGaussianBlur>
            </filter>
            <linearGradient
              x1="95.4603154%"
              y1="50%"
              x2="8.89368913%"
              y2="50%"
              id="last_linearGradient-28"
            >
              <stop stopColor="#DADADA" offset="0%"></stop>
              <stop
                stopColor="#FFFFFF"
                stopOpacity="0"
                offset="23.8168353%"
              ></stop>
              <stop
                stopColor="#FFFFFF"
                stopOpacity="0.108808435"
                offset="53.5246568%"
              ></stop>
              <stop
                stopColor="#FFFFFF"
                stopOpacity="0.2"
                offset="78.6953142%"
              ></stop>
              <stop stopColor="#DDDDDD" offset="100%"></stop>
            </linearGradient>
            <filter
              x="-1.2%"
              y="-0.8%"
              width="102.4%"
              height="101.5%"
              filterUnits="objectBoundingBox"
              id="last_filter-29"
            >
              <feGaussianBlur
                stdDeviation="2"
                in="SourceGraphic"
              ></feGaussianBlur>
            </filter>
            <linearGradient
              x1="14.85524%"
              y1="50%"
              x2="83.1860302%"
              y2="50%"
              id="last_linearGradient-30"
            >
              <stop stopColor="#E8E8E8" offset="0%"></stop>
              <stop
                stopColor="#FFFFFF"
                stopOpacity="0"
                offset="32.5754155%"
              ></stop>
              <stop
                stopColor="#FFFFFF"
                stopOpacity="0.7"
                offset="62.8590137%"
              ></stop>
              <stop
                stopColor="#FFFFFF"
                stopOpacity="0"
                offset="78.9130238%"
              ></stop>
              <stop stopColor="#E8E8E8" offset="100%"></stop>
            </linearGradient>
            <filter
              x="-1.2%"
              y="-19.4%"
              width="102.4%"
              height="138.7%"
              filterUnits="objectBoundingBox"
              id="last_filter-31"
            >
              <feGaussianBlur
                stdDeviation="2"
                in="SourceGraphic"
              ></feGaussianBlur>
            </filter>
            <filter
              x="-3.5%"
              y="-1.9%"
              width="106.9%"
              height="103.7%"
              filterUnits="objectBoundingBox"
              id="last_filter-32"
            >
              <feGaussianBlur
                stdDeviation="7"
                in="SourceGraphic"
              ></feGaussianBlur>
            </filter>
            <filter
              x="-8.3%"
              y="-1.6%"
              width="116.6%"
              height="103.2%"
              filterUnits="objectBoundingBox"
              id="last_filter-33"
            >
              <feGaussianBlur
                stdDeviation="4.18985132"
                in="SourceGraphic"
              ></feGaussianBlur>
            </filter>
          </defs>
          <g
            id="last_lippysvg"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g id="last_Group" transform="translate(550.000000, 386.000000)">
              <polygon
                id="last_Mask"
                fill="url(#last_linearGradient-1)"
                points="926 1199 1551.9603 1199 1551.9603 2238.949 926 2238.949"
              ></polygon>
              <path
                d="M1533.2013,0.137 L945.1213,0.137 C934.6613,0.137 926.1803,8.616 926.1803,19.076 L926.1803,1179.269 L1552.1413,1179.269 L1552.1413,19.076 C1552.1413,8.616 1543.6613,0.137 1533.2013,0.137"
                id="last_Fill-4"
                fill="url(#last_linearGradient-2)"
              ></path>
              <path
                d="M1533.021,0 L944.941,0 C934.481,0 926,8.479 926,18.939 L926,1179.132 L1551.961,1179.132 L1551.961,18.939 C1551.961,8.479 1543.481,0 1533.021,0"
                id="last_Fill-4"
                fillOpacity="0.3"
                fill="url(#last_linearGradient-3)"
              ></path>
              <path
                d="M926,2198.22237 C926,2220.7448 934.479542,2239 944.94121,2239 L1533.05879,2239 C1543.51946,2239 1552,2220.7448 1552,2198.22237 L1552,0 L926,0 L926,2198.22237 Z"
                id="last_Fill-10-Copy-2"
                fillOpacity="0.8"
                fill="url(#last_linearGradient-4)"
                opacity="0.6"
              ></path>
                <image x="990" y="400" xlinkHref={selectedIconImageURL} width="500" height="500" id="iconImage"/>
              <g
                id="last_Group-38"
                transform="translate(1032.000000, 1943.000000)"
                fill="#383837"
              >
                <g
                  id="last_iconlipstick"
                  transform="translate(58.000000, -1500.000000)"
                ></g>
                <polygon
                  id="last_Fill-1"
                  points="22.2498 175.6847 13.2288 191.9507 4.1608 175.6847 0.0008 175.6847 11.3118 195.8767 11.3118 208.0307 15.0988 208.0307 15.0988 195.8767 26.4088 175.6847"
                ></polygon>
                <g id="last_Group-37" transform="translate(0.000000, 0.666000)">
                  <path
                    d="M43.9761,177.8709 C36.9641,177.8709 31.1681,183.3879 31.1681,191.1929 C31.1681,198.9989 36.9641,204.5609 43.9761,204.5609 C50.9881,204.5609 56.7841,198.9989 56.7841,191.1929 C56.7841,183.3879 50.9881,177.8709 43.9761,177.8709 M43.9761,207.9249 C34.6281,207.9249 27.2891,200.6799 27.2891,191.1929 C27.2891,181.7039 34.6281,174.5039 43.9761,174.5039 C53.3251,174.5039 60.6631,181.7039 60.6631,191.1929 C60.6631,200.6799 53.3251,207.9249 43.9761,207.9249"
                    id="last_Fill-2"
                  ></path>
                  <path
                    d="M88.3218,194.4178 L88.3218,175.0188 L92.1078,175.0188 L92.1078,194.9788 C92.1078,202.9718 87.5278,207.9248 79.5348,207.9248 C71.5418,207.9248 66.9608,202.9718 66.9608,194.9788 L66.9608,175.0188 L70.7468,175.0188 L70.7468,194.4178 C70.7468,200.8668 73.6908,204.5618 79.5348,204.5618 C85.3778,204.5618 88.3218,200.8668 88.3218,194.4178"
                    id="last_Fill-4"
                  ></path>
                  <path
                    d="M110.7476,189.1346 C115.3756,189.1346 117.4326,187.2666 117.4326,183.7596 C117.4326,180.2536 115.3756,178.3856 110.7476,178.3856 L104.2976,178.3856 L104.2976,189.1346 L110.7476,189.1346 Z M104.2976,207.3646 L100.5116,207.3646 L100.5116,175.0186 L110.6076,175.0186 C116.9646,175.0186 121.2186,178.0096 121.2186,183.7596 C121.2186,188.5286 118.2736,191.4266 113.6456,192.2196 L123.6016,207.3646 L119.3016,207.3646 L109.5316,192.5006 L104.2976,192.5006 L104.2976,207.3646 Z"
                    id="last_Fill-6"
                  ></path>
                  <path
                    d="M155.3286,177.8709 C148.3166,177.8709 142.5206,183.3879 142.5206,191.1929 C142.5206,198.9989 148.3166,204.5609 155.3286,204.5609 C162.3406,204.5609 168.1366,198.9989 168.1366,191.1929 C168.1366,183.3879 162.3406,177.8709 155.3286,177.8709 M155.3286,207.9249 C145.9796,207.9249 138.6416,200.6799 138.6416,191.1929 C138.6416,181.7039 145.9796,174.5039 155.3286,174.5039 C164.6776,174.5039 172.0156,181.7039 172.0156,191.1929 C172.0156,200.6799 164.6776,207.9249 155.3286,207.9249"
                    id="last_Fill-8"
                  ></path>
                  <polygon
                    id="last_Fill-10"
                    points="178.688 207.365 178.688 175.018 182.567 175.018 199.3 201.288 199.3 175.018 203.086 175.018 203.086 207.365 199.208 207.365 182.473 181.05 182.473 207.365"
                  ></polygon>
                  <polygon
                    id="last_Fill-12"
                    points="211.769 175.0184 231.028 175.0184 231.028 178.3854 215.556 178.3854 215.556 189.0424 229.111 189.0424 229.111 192.4074 215.556 192.4074 215.556 204.0004 231.028 204.0004 231.028 207.3654 211.769 207.3654"
                  ></polygon>
                  <path
                    d="M257.0044,204.8396 C259.6694,204.8396 262.6144,203.4386 264.4384,200.4016 L256.0244,190.6296 L255.9294,190.5386 C252.5644,192.9216 250.7414,195.7256 250.7414,198.5776 C250.7414,202.0836 253.3124,204.8396 257.0044,204.8396 Z M271.8694,208.9996 L265.7454,201.8966 C263.8294,206.0566 260.4634,207.9246 256.7714,207.9246 C250.6024,207.9246 247.0964,203.7646 247.0964,198.7626 C247.0964,194.8386 249.8074,190.9116 254.0134,188.2926 C252.2834,186.1436 250.7414,183.7596 250.7414,181.1896 C250.7414,177.3566 254.1534,174.5036 258.7344,174.5036 C262.7074,174.5036 266.5404,177.1686 266.5404,182.0306 L262.9414,182.0306 C262.9414,179.0846 260.8844,177.5896 258.5004,177.5896 C256.1644,177.5896 254.2474,178.8516 254.2474,181.2826 C254.2474,183.9466 256.4434,186.2366 258.3144,188.4346 L271.8694,204.1856 L271.8694,208.9996 Z"
                    id="last_Fill-14"
                  ></path>
                  <path
                    d="M302.9858,177.8709 C295.9748,177.8709 290.1778,183.3879 290.1778,191.1929 C290.1778,198.9989 295.9748,204.5609 302.9858,204.5609 C309.9978,204.5609 315.7928,198.9989 315.7928,191.1929 C315.7928,183.3879 309.9978,177.8709 302.9858,177.8709 M302.9858,207.9249 C293.6378,207.9249 286.2988,200.6799 286.2988,191.1929 C286.2988,181.7039 293.6378,174.5039 302.9858,174.5039 C312.3348,174.5039 319.6728,181.7039 319.6728,191.1929 C319.6728,200.6799 312.3348,207.9249 302.9858,207.9249"
                    id="last_Fill-16"
                  ></path>
                  <polygon
                    id="last_Fill-18"
                    points="326.3462 207.365 326.3462 175.018 330.2252 175.018 346.9582 201.288 346.9582 175.018 350.7452 175.018 350.7452 207.365 346.8672 207.365 330.1312 181.05 330.1312 207.365"
                  ></polygon>
                  <polygon
                    id="last_Fill-20"
                    points="359.4282 175.0184 363.2142 175.0184 363.2142 204.0004 378.0322 204.0004 378.0322 207.3654 359.4282 207.3654"
                  ></polygon>
                  <polygon
                    id="last_Fill-22"
                    points="397.6587 175.0184 401.8177 175.0184 390.5067 195.2104 390.5067 207.3654 386.7207 207.3654 386.7207 195.2104 375.4087 175.0184 379.5687 175.0184 388.6377 191.2844"
                  ></polygon>
                  <g
                    id="last_Group-26"
                    transform="translate(105.000000, 0.000000)"
                  >
                    <path
                      d="M70.1001,125.9646 C40.7871,125.9646 16.5541,102.7096 16.5541,70.0726 C16.5541,37.4376 40.7871,14.3776 70.1001,14.3776 C99.4141,14.3776 123.6471,37.4376 123.6471,70.0726 C123.6471,102.7096 99.4141,125.9646 70.1001,125.9646 M70.1001,0.3336 C31.0151,0.3336 0.3621,30.4026 0.3621,70.0726 C0.3621,109.7436 31.0151,140.0076 70.1001,140.0076 C109.1861,140.0076 139.8391,109.7436 139.8391,70.0726 C139.8391,30.4026 109.1861,0.3336 70.1001,0.3336"
                      id="last_Fill-24"
                    ></path>
                  </g>
                  <g
                    id="last_Group-29"
                    transform="translate(262.000000, 0.000000)"
                  >
                    <path
                      d="M70.0776,125.9646 C40.7646,125.9646 16.5306,102.7096 16.5306,70.0726 C16.5306,37.4376 40.7646,14.3776 70.0776,14.3776 C99.3916,14.3776 123.6256,37.4376 123.6256,70.0726 C123.6256,102.7096 99.3916,125.9646 70.0776,125.9646 M70.0776,0.3336 C30.9926,0.3336 0.3396,30.4026 0.3396,70.0726 C0.3396,109.7436 30.9926,140.0076 70.0776,140.0076 C109.1636,140.0076 139.8176,109.7436 139.8176,70.0726 C139.8176,30.4026 109.1636,0.3336 70.0776,0.3336"
                      id="last_Fill-27"
                    ></path>
                  </g>
                  <polygon
                    id="last_Fill-30"
                    points="92.978 2.4832 55.281 70.4632 17.389 2.4832 0 2.4832 47.283 86.8732 47.283 137.6632 63.084 137.6632 63.084 86.8732 110.367 2.4832"
                  ></polygon>
                  <path
                    d="M403.2554,9.9168 L401.4944,9.9168 L401.4944,7.1298 L403.2554,7.1298 C404.3124,7.1298 404.9284,7.6288 404.9284,8.5378 C404.9284,9.4468 404.3124,9.9168 403.2554,9.9168 M406.7994,8.5378 C406.7994,6.5738 405.3084,5.4918 403.1374,5.4918 L399.6224,5.4918 L399.6224,15.9238 L401.4944,15.9238 L401.4944,11.5548 L402.6394,11.5548 L405.4834,15.9238 L407.6204,15.9238 L404.6054,11.3508 C405.9504,10.9708 406.7994,10.0048 406.7994,8.5378"
                    id="last_Fill-32"
                  ></path>
                  <g
                    id="last_Group-36"
                    transform="translate(392.000000, 0.000000)"
                  >
                    <path
                      d="M10.9028,19.4998 C6.1278,19.4998 2.4028,15.6598 2.4028,10.7948 C2.4028,5.9308 6.1278,2.0888 10.9028,2.0888 C15.6788,2.0888 19.4048,5.9308 19.4048,10.7948 C19.4048,15.6598 15.6788,19.4998 10.9028,19.4998 M10.9028,0.3338 C5.0718,0.3338 0.4428,5.0218 0.4428,10.7948 C0.4428,16.5678 5.0718,21.2838 10.9028,21.2838 C16.7348,21.2838 21.3638,16.5678 21.3638,10.7948 C21.3638,5.0218 16.7348,0.3338 10.9028,0.3338"
                      id="last_Fill-34"
                    ></path>
                  </g>
                </g>
              </g>
              <path
                d="M1547.1954,1189.1593 C1547.1954,1183.6963 1549.4094,1179.2683 1552.1414,1179.2683 L926.1804,1179.2683 C928.9124,1179.2683 931.1274,1183.6963 931.1274,1189.1593 C931.1274,1194.6223 928.9124,1199.0513 926.1804,1199.0513 L1552.1414,1199.0513 C1549.4094,1199.0513 1547.1954,1194.6223 1547.1954,1189.1593"
                id="last_Fill-7"
                fill="url(#last_linearGradient-5)"
              ></path>
              <path
                d="M0,2220.05907 C0,2230.52058 8.47954182,2239 18.9412103,2239 L607.05879,2239 C617.519458,2239 626,2230.52058 626,2220.05907 L626,1199 L0,1199 L0,2220.05907 Z"
                id="last_Fill-10"
                fill="url(#last_linearGradient-1)"
              ></path>
              <path
                d="M621.0147,1189.1593 C621.0147,1183.6963 623.2287,1179.2683 625.9597,1179.2683 L-0.0003,1179.2683 C2.7317,1179.2683 4.9457,1183.6963 4.9457,1189.1593 C4.9457,1194.6223 2.7317,1199.0513 -0.0003,1199.0513 L625.9597,1199.0513 C623.2287,1199.0513 621.0147,1194.6223 621.0147,1189.1593"
                id="last_Fill-13"
                fill="url(#last_linearGradient-5)"
              ></path>
              <path
                d="M0,2198.22237 C0,2220.7448 8.47954182,2239 18.9412103,2239 L607.05879,2239 C617.519458,2239 626,2220.7448 626,2198.22237 L626,0 L0,0 L0,2198.22237 Z"
                id="last_Fill-10-Copy-2"
                fillOpacity="0.8"
                fill="url(#last_linearGradient-4)"
                opacity="0.6"
              ></path>
              <path
                d="M564,287.834057 C564,284.217371 560.719379,281.484014 557.123507,282.082494 C484.071152,294.270449 401.046832,301.161407 313.0005,301.161407 C224.953168,301.161407 141.929848,294.270449 68.876493,282.082494 C65.2806206,281.484014 62,284.217371 62,287.834057 C62,290.67659 64.0596453,293.112196 66.8849021,293.588598 C140.419642,305.983986 224.153529,313 313.0005,313 C401.847472,313 485.580358,305.983986 559.116099,293.588598 C561.941356,293.112196 564,290.67659 564,287.834057"
                id="last_Fill-21"
                fill="url(#last_linearGradient-6)"
                opacity="0.6"
                filter="url(#last_filter-7)"
              ></path>
              <path
                d="M607.05879,0 L18.9412103,0 C8.47954182,0 0,8.4780508 0,18.9368798 L0,1179 L62.1849735,1179 L62.1849735,94.8413816 C62.1849735,85.066476 68.9804077,77.1423632 77.3629433,77.1423632 L548.637057,77.1423632 C557.019592,77.1423632 563.815027,85.066476 563.815027,94.8413816 L563.815027,1179 L626,1179 L626,18.9368798 C626,8.4780508 617.519458,0 607.05879,0"
                id="last_Fill-25"
                fill="url(#last_linearGradient-2)"
              ></path>
              <g
                id="last_Group-11-Copy"
                transform="translate(47.000000, 216.000000)"
              ></g>
              <path
                d="M146,1050.62238 L471.2064,1050.62238 C472.634011,730.276565 472.634011,554.634481 471.2064,523.69613 C467.11055,434.933239 437.27598,362.7226 374.194436,259.737803 C373.541504,258.671849 365.167549,247.31214 349.072569,225.658676 L349.07257,225.658675 C339.270381,212.47125 320.690153,209.609336 307.373935,219.235832 C199.791312,297.00894 146,394.324386 146,511.18217 C146,636.583306 146,816.396711 146,1050.62238 Z"
                id="Oval-3-Copy-2"
                fill="#E488CC"
                style={{ fill: colorSelected }}
              ></path>
              <path
                d="M146,1050.62238 L471.2064,1050.62238 C472.634011,730.276565 472.634011,554.634481 471.2064,523.69613 C467.11055,434.933239 437.27598,362.7226 374.194436,259.737803 C373.541504,258.671849 365.167549,247.31214 349.072569,225.658676 L349.07257,225.658675 C339.270381,212.47125 320.690153,209.609336 307.373935,219.235832 C199.791312,297.00894 146,394.324386 146,511.18217 C146,636.583306 146,816.396711 146,1050.62238 Z"
                id="last_Oval-3-Copy-3"
                fill="url(#last_linearGradient-8)"
                opacity="0.8"
                style={{ mixBlendMode: "overlay" }}
              ></path>
              <path
                d="M265,1053.63602 L265,444.79799 C314.458985,429.755171 374.054723,395.526357 386.459428,319 C415.61923,379.996218 430.494468,434.27164 433.388124,496.150147 C434.918818,528.882799 434.918818,714.711425 433.388124,1053.63602 L265,1053.63602 Z"
                id="last_Combined-Shape-Copy-2"
                fill="url(#last_linearGradient-9)"
                opacity="0.046875"
                filter="url(#last_filter-10)"
              ></path>
              <path
                d="M400.708544,1057.67982 L315.404128,1057.67982 C316.96292,719.667911 316.961458,534.325894 315.399743,501.653765 C314.478755,482.386062 312.36924,463.856208 309,445.630966 C334.069364,436.873869 360.52465,423.205542 381.707827,402 C392.700014,437.549942 398.828021,472.751378 400.592677,510.740212 C402.116228,543.538635 402.15485,725.851837 400.708544,1057.67982 Z"
                id="last_Combined-Shape-Copy-3"
                fill="url(#last_linearGradient-11)"
                opacity="0.247076"
                filter="url(#last_filter-12)"
              ></path>
              <path
                d="M146,985.000004 L472.277108,985.000004 C472.193449,1006.05681 472.10325,1027.79837 472.006512,1050.22469 L146,1050.22469 C146,1028.01056 146,1006.26899 146,985 Z"
                id="last_Combined-Shape-Copy-4"
                fillOpacity="0.3"
                fill="url(#last_radialGradient-13)"
              ></path>
              <path
                d="M262.479678,432.704232 C278.242172,432.704232 389.325301,423.47881 389.325301,322.172885 C389.325301,308.702275 381.477653,285.938825 373.542869,272.923583 C368.980779,265.440494 359.329069,250.221593 344.587739,227.26688 L344.58774,227.266879 C335.624933,213.310293 317.045094,209.262034 303.088507,218.224841 C302.148068,218.828783 301.242076,219.484752 300.374758,220.189685 C271.983308,243.265524 252.261368,260.84349 241.208937,272.923583 C213.824227,302.85454 199.012603,327.980773 192.973881,346.642748 C178.916953,419.742756 243.90862,432.704232 262.479678,432.704232 Z"
                id="last_Oval-3-Copy-4"
                fill="url(#last_radialGradient-14)"
                opacity="0.648604911"
              ></path>
              <path
                d="M262.479678,436.704232 C278.242172,436.704232 389.325301,427.47881 389.325301,326.172885 C389.325301,312.702275 381.477653,289.938825 373.542869,276.923583 C368.980779,269.440494 359.329069,254.221593 344.587739,231.26688 L344.58774,231.266879 C335.624933,217.310293 317.045094,213.262034 303.088507,222.224841 C302.148068,222.828783 301.242076,223.484752 300.374758,224.189685 C271.983308,247.265524 252.261368,264.84349 241.208937,276.923583 C213.824227,306.85454 199.012603,331.980773 192.973881,350.642748 C178.916953,423.742756 243.90862,436.704232 262.479678,436.704232 Z"
                id="last_Oval-3-Copy-5"
                fill="url(#last_radialGradient-15)"
                style={{ mixBlendMode: "overlay" }}
              ></path>
              <path
                d="M67.2655962,1048 L559.734404,1048 C562.642512,1048 565,1050.35749 565,1053.2656 L565,1179 L62,1179 L62,1053.2656 C62,1050.35749 64.3574877,1048 67.2655962,1048 Z"
                id="last_Rectangle-7-Copy-2"
                fill="url(#last_linearGradient-16)"
              ></path>
              <polygon
                id="last_Rectangle-7-Copy-3"
                fill="url(#last_linearGradient-17)"
                points="62 1048 565 1048 565 1179 62 1179"
              ></polygon>
              <polygon
                id="last_Rectangle-8-Copy-2"
                fill="url(#last_linearGradient-18)"
                opacity="0.60352"
                transform="translate(385.500000, 1113.500000) rotate(-180.000000) translate(-385.500000, -1113.500000) "
                points="365 1048 406 1048 406 1179 365 1179"
              ></polygon>
              <path
                d="M62,1048.00001 L565,1048.00001 C564.871027,1090.29137 564.731974,1133.95804 564.58284,1179 L62,1179 C62,1134.3842 62,1090.71754 62,1048 Z"
                id="last_Combined-Shape-Copy-5"
                fillOpacity="0.7"
                fill="url(#last_radialGradient-19)"
              ></path>
              <polygon
                id="last_Rectangle-7-Copy-5"
                fillOpacity="0.5"
                fill="url(#last_linearGradient-20)"
                style={{ mixBlendMode: "multiply" }}
                opacity="0.7"
                points="62 1048 564 1048 564 1179 62 1179"
              ></polygon>
              <polygon
                id="last_Rectangle-8-Copy-5"
                fill="url(#last_linearGradient-21)"
                opacity="0.6"
                points="70 1048 98 1048 98 1179 70 1179"
              ></polygon>
              <polygon
                id="last_Rectangle-8-Copy-6"
                fill="url(#last_linearGradient-22)"
                opacity="0.6"
                transform="translate(551.000000, 1113.500000) rotate(-180.000000) translate(-551.000000, -1113.500000) "
                points="537 1048 565 1048 565 1179 537 1179"
              ></polygon>
              <polygon
                id="last_Rectangle-8-Copy-7"
                fill="url(#last_linearGradient-22)"
                opacity="0.6"
                transform="translate(544.000000, 1113.500000) rotate(-180.000000) translate(-544.000000, -1113.500000) "
                points="530 1048 558 1048 558 1179 530 1179"
              ></polygon>
              <path
                d="M191.354477,362.198086 C186.879172,417.98264 225.659307,436.845246 257.983733,439.352218 C292.66627,442.042077 391.696605,420.719502 389.28191,324.578333 C388.786846,304.867347 379.060479,282.45556 371.230386,269.257488 C366.810699,261.80785 357.5503,247.728977 343.44919,227.020868 C334.113459,213.310933 315.431256,209.764939 301.721321,219.100669 C300.912337,219.651544 300.130765,220.241635 299.379403,220.86883 C299.011452,221.175974 298.64497,221.482162 298.279956,221.787393 C299.339738,220.901185 300.459405,220.089157 301.630979,219.357093 C315.69738,210.567637 334.225713,214.845446 343.01517,228.911847 C357.360441,251.869617 366.765512,267.111403 371.230386,274.637205 C379.060479,287.835278 386.804586,310.918496 386.804586,324.578333 C386.804586,427.307344 277.187084,436.662359 261.63256,436.662359 C244.416272,436.662359 186.77175,425.062443 191.354478,362.19808 Z"
                id="last_Combined-Shape-Copy-7"
                fill="url(#last_radialGradient-23)"
                opacity="0.648604911"
                style={{ mixBlendMode: "overlay" }}
              ></path>
              <path
                d="M523,1113.5 C523,1129.79203 509.792813,1143 493.499498,1143 C477.207187,1143 464,1129.79203 464,1113.5 C464,1097.20696 477.207187,1084 493.499498,1084 C509.792813,1084 523,1097.20696 523,1113.5"
                id="last_Fill-23"
                fill="url(#last_radialGradient-24)"
              ></path>
              <path
                d="M161,1113.5 C161,1129.79203 147.792813,1143 131.499498,1143 C115.207187,1143 102,1129.79203 102,1113.5 C102,1097.20696 115.207187,1084 131.499498,1084 C147.792813,1084 161,1097.20696 161,1113.5"
                id="last_Fill-23-Copy"
                fill="url(#last_radialGradient-24)"
              ></path>
              <path
                d="M162,1103.5 C162,1114.82158 152.822125,1124 141.499651,1124 C130.177875,1124 121,1114.82158 121,1103.5 C121,1092.17772 130.177875,1083 141.499651,1083 C152.822125,1083 162,1092.17772 162,1103.5"
                id="last_Fill-23-Copy"
                fillOpacity="0.6"
                fill="url(#last_radialGradient-25)"
                style={{ mixBlendMode: "multiply" }}
                filter="url(#last_filter-26)"
              ></path>
              <path
                d="M523,1103.5 C523,1114.82158 513.822125,1124 502.499651,1124 C491.177875,1124 482,1114.82158 482,1103.5 C482,1092.17772 491.177875,1083 502.499651,1083 C513.822125,1083 523,1092.17772 523,1103.5"
                id="last_Fill-23-Copy-2"
                fillOpacity="0.6"
                fill="url(#last_radialGradient-25)"
                style={{ mixBlendMode: "multiply" }}
                filter="url(#last_filter-27)"
              ></path>
              <path
                d="M557.124494,282.402871 C478,272 401.047508,272 313,272 C224.953493,272 149,272 68.8755059,282.402871 C65.2825993,282.869352 62.0160128,284.42674 62.0010008,287.862194 C62.0010008,287.85707 62,287.852801 62,287.847677 L62,287.885251 L62,1048.32377 L564,1048.32377 L564,287.885251 L564,287.847677 C564,287.852801 563.998999,287.85707 563.998999,287.862194 C563.983987,284.42674 560.718371,282.875375 557.124494,282.402871 Z"
                id="last_Fill-19"
                fill="url(#last_linearGradient-28)"
                opacity="0.8"
                filter="url(#last_filter-29)"
              ></path>
              <path
                d="M62,286.166544 C62,289.783316 65.2806206,292.516739 68.876493,291.917252 C141.928848,279.729999 224.953168,272.837883 312.9995,272.837883 C401.046832,272.837883 484.070152,279.729999 557.123507,291.917252 C560.719379,292.516739 564,289.783316 564,286.166544 C564,283.323943 561.941356,280.888279 559.115098,280.411865 C485.580358,268.016181 401.846471,261 312.9995,261 C224.152528,261 140.419642,268.016181 66.8839013,280.411865 C64.0586445,280.888279 62,283.323943 62,286.166544"
                id="last_Fill-17"
                fill="url(#last_linearGradient-30)"
                filter="url(#last_filter-31)"
              ></path>
              <polygon
                id="last_Rectangle-8-Copy-3"
                fill="url(#last_linearGradient-21)"
                points="10 33 31 33 31 1158 10 1158"
              ></polygon>
              <polygon
                id="last_Rectangle-8-Copy-4"
                fill="url(#last_linearGradient-21)"
                points="568 33 589 33 589 1050 568 1050"
              ></polygon>
              <path
                d="M614,1158 L614,62.3298607 C614,46.1572932 598.851802,33 580.231406,33 L7,33 L7,54.5516678 L580.231406,54.5516678 C587.415128,54.5516678 592.42137,58.6504032 592.42137,62.3298607 L592.42137,1158 L614,1158 Z"
                id="last_Fill-15"
                fillOpacity="0.3"
                fill="#D6D3D9"
                style={{ mixBlendMode: "multiply" }}
                filter="url(#last_filter-32)"
              ></path>
              <path
                d="M260.649304,1058 L121.466453,1058 C124.006597,658.993993 124.004474,440.208858 121.460084,401.644595 C119.956594,378.856829 116.508806,356.943538 111,335.390188 C151.866301,325.118496 195.071072,309.045348 229.681773,284.047849 C247.597348,326.02371 257.584616,367.587019 260.460084,412.442392 C262.94188,451.156751 263.004954,666.34262 260.649304,1058 Z"
                id="last_Combined-Shape-Copy-3"
                fill="url(#last_linearGradient-11)"
                opacity="0.247076"
                filter="url(#last_filter-33)"
                transform="translate(186.684985, 671.023925) scale(-1, 1) translate(-186.684985, -671.023925) "
              ></path>

              <text
                xmlns="http://www.w3.org/2000/svg"
                textAnchor="middle"
                id="last_lipstickmessage"
                style={{
                  fontSize: "90px",
                  fill: "#000"
                }}
                transform="translate(310.000000, 2100.500000)"
              >{message}</text>
            </g>
          </g>
        </svg>
          </div>
      </div>
    );
  }
}
